import { FC, useMemo } from "react";

import { GARTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GarFormProps } from "@/types/form-types";

import { getGarSchema } from "./schema/gar-schema";
import { garUiSchema } from "./schema/gar-ui-schema";

const GarForm: FC<GarFormProps> = (props) => {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();

  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { formData, handleChange } = useBrostarFormDataStorage<GARTask>({
    key: "gar",
    task,
  });

  const garSchema = useMemo(() => getGarSchema({ type }), [type]);

  const onSubmit = async () => {
    if (!formData) return;
    await api.createGar(formData);
    if (oldUploadTask && oldUploadTask.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm<GARTask>
      schema={garSchema}
      uiSchema={garUiSchema}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
      formData={formData}
      onChange={handleChange}
    />
  );
};

export { GarForm };
